









































































































































































import {Vue, Component, Provide, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import Role from '@/models/role';
import validator from '@/utils/validator';
import validationMsgs from '@/constants/validation';
import {redirectTime} from '@/constants/constants';
import {createRole, getRolePageGroups, getRoleCompanies, getRoleShips} from '@/services/api/roles';
import {getShipList, getAllowedShipListForRole} from '@/services/api/common';
import {Utils} from '@/utils/Utils';

@Component({
  computed: {
    ...mapGetters(['userDetails']),
    getInspectionShip() {
      if (this.utils.isSuperAdmin()) return this.selectedShips;
      else return this.ships;
    },
  },

  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast', 'setupAppData']),
  },
  // computed: {
  //   ...mapGetters(['shipList']),
  // },
})
export default class CreateRole extends Vue {
  roleData: Role = {
    groupName: '',
    active: false,
    companyId: -1,
    ships: [],
  };

  //loader and helper variables
  isScreenLoading = true;
  saving = false;
  showSuccessToast: any;
  showErrorToast: any;
  setupAppData: any;

  allPageGroups: any[] = [];
  ships: any[] = [];
  companies: any[] = [];
  pageGroups: any[] = [];
  selectedShips: any[] = [];
  selectedShipsForInspection: any[] = [];
  utils = Utils;
  isSuperAdmin = this.utils.isSuperAdmin();
  isAdmin = this.utils.isAdmin();

  //for data
  shipList: any[] = [];

  //validation variables
  roleNameValidationMsg = null;
  companyValidationMsg = null;
  shipValidationMsg = null;
  inspectionShipValidationMsg = null;
  userDetails: any;

  mounted() {
    this.setupRolePage();
  }

  //view setup based on permission
  async setupRolePage() {
    try {
      const permsReq = getRolePageGroups();

      let shipsReq = null;
      if (this.isSuperAdmin) shipsReq = getShipList();
      else if (this.isAdmin) shipsReq = getAllowedShipListForRole();

      const companiesReq = getRoleCompanies();

      const response = await Promise.all([permsReq, shipsReq, companiesReq]);

      const pageGroupsResponse: any = response[0].data; //groups list
      this.allPageGroups = pageGroupsResponse;
      this.setPermissions();

      const shipsResponse: [] = response[1].data; //ships list

      this.ships = shipsResponse.map((ship: any) => {
        return {value: ship.shipId, label: ship.name};
      });

      const companyResponse: any = response[2].response; //company list
      this.companies = companyResponse.data.map((comp: any) => {
        return {id: comp.id, displayName: comp.name};
      });
    } catch (e) {
      //
    } finally {
      this.isScreenLoading = false;
    }
  }

  //validation functions
  validateRoleName() {
    const name = this.roleData.groupName;
    if (validator.isNullOrEmpty(name)) {
      this.roleNameValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.roleNameValidationMsg = null;
      return true;
    }
  }

  //validate company
  validateCompany() {
    const id = this.roleData.companyId;
    if (id === -1) {
      this.companyValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.companyValidationMsg = null;
      return true;
    }
  }
  //validate ship
  validateShip() {
    if (this.utils.isSuperAdmin()) {
      if (this.selectedShips.length < 1) {
        this.shipValidationMsg = validationMsgs.required;
        return false;
      } else {
        this.shipValidationMsg = null;
        return true;
      }
    } else {
      this.shipValidationMsg = null;
      return true;
    }
  }

  // validate inspection ships
  validateInspectionShip() {
    if (this.selectedShipsForInspection.length < 1) {
      this.inspectionShipValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.inspectionShipValidationMsg = null;
      return true;
    }
  }

  //Validate all
  validateAll() {
    return this.validateRoleName() && this.validateCompany() && this.validateInspectionShip() && this.validateShip();
  }

  //submit button handler
  async createRoleHandler() {
    if (!this.validateAll()) {
      return;
    }
    let role = {
      GroupName: this.roleData.groupName,
      Active: this.roleData.active,
      PageAuthorities: this.getauthroitiesForPost(),
      Companies: this.getCompaniesForPost(),
    };
    this.saving = true;
    try {
      let response: any = await createRole(role);
      if (response.data) {
        let message: string = response.message;
        if (message.includes('Successfully created')) message = 'Record added successfully';
        this.showSuccessToast({msg: message});
        this.setupAppData();
        setTimeout(() => this.$router.go(-1), redirectTime);
      } else {
        let errorMsg = response.error;
        this.showErrorToast({msg: errorMsg});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.saving = false;
    }
  }
  //helpe methods
  setSelectedShips() {
    this.selectedShips = this.ships.filter((sh) => this.roleData.ships.includes(sh.value));
  }

  getShipsForPost(selectedShips) {
    const ships = selectedShips.map((sel) => {
      return {ShipId: sel.value};
    });
    return ships;
  }
  getCompaniesForPost() {
    return [{CompanyId: this.roleData.companyId}];
  }
  getauthroitiesForPost() {
    let modifiedGrp = this.pageGroups.map((group) => {
      if (group.pageGroupId === 1) {
        return {
          pageGroupId: group.pageGroupId,
          authoritiesId: group.value,
          ships: this.getShipsForPost(this.selectedShipsForInspection),
        };
      } else if (group.pageGroupId === 4) {
        return {
          pageGroupId: group.pageGroupId,
          authoritiesId: group.value,
          ships: this.getShipsForPost(this.selectedShips),
        };
      } else return {pageGroupId: group.pageGroupId, authoritiesId: group.value};
    });

    return modifiedGrp;
  }

  //set permission to role
  setPermissions() {
    const perms: any[] = []; //this.roleData.groupAuthorities;
    this.pageGroups = this.allPageGroups.map((group) => {
      const data = perms.find((perm) => group.pageGroupID === perm.pageGroupId);
      return {
        name: group.pageGroupName,
        pageGroupId: group.pageGroupID,
        options: this.getDisplayValues(group.authorities),
        value: data ? data.authoritiesId : group.authorities[0]['authoritiesId'],
      };
    });
  }

  // show permission options as radio button
  getDisplayValues = (auths) => {
    return auths.map((auth) => {
      if (auth.authorityName !== 'Disable') return {id: auth.authoritiesId, displayName: auth.authorityName};
      else return {id: 6, displayName: 'Disable'};
    });
  };
}
